// extracted by mini-css-extract-plugin
export default {"button":"button_button__WY7Q8","small":"button_small__KpWsC","right":"button_right__YDrLq"};